import { useState, useEffect } from "react";
import "./index.css";
import { Portfolio } from "./Portfolio";
import { Impressum } from "./Impressum";
import { BlogList } from "./blog/BlogList";
import { BlogPost } from "./blog/BlogPost";
import { AdminPanel } from "./admin/AdminPanel";

type PageState =
  | { page: "portfolio" }
  | { page: "impressum" }
  | { page: "blog-list" }
  | { page: "blog-post"; slug: string }
  | { page: "admin" };

function getPage(): PageState {
  const hash = window.location.hash;
  if (hash === "#impressum") return { page: "impressum" };
  if (hash === "#admin" || hash.startsWith("#admin/")) return { page: "admin" };
  if (hash.startsWith("#blog/")) {
    const slug = hash.slice(6);
    return slug ? { page: "blog-post", slug } : { page: "blog-list" };
  }
  if (hash === "#blog") return { page: "blog-list" };
  return { page: "portfolio" };
}

export function App() {
  const [state, setState] = useState<PageState>(getPage);

  useEffect(() => {
    const onHash = () => setState(getPage());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  switch (state.page) {
    case "impressum":  return <Impressum />;
    case "blog-list":  return <BlogList />;
    case "blog-post":  return <BlogPost slug={state.slug} />;
    case "admin":      return <AdminPanel />;
    default:           return <Portfolio />;
  }
}

export default App;
